/**
 * Which Tier-2 / Tier-3 rule sections each ingestion provider contributes to its
 * rules page (`docs/platform/learned-match-rules-design.md` § 5c).
 *
 * This lives at the app composition layer, not in `shared/ingestion/`, for one
 * reason: `shared/` may not import a module, and these sections are module-shaped
 * by nature (a Tier-2 default carries accounting's own expense account and tax
 * rate; a Tier-3 automation carries its condition/action vocabulary). App is the
 * one layer that legitimately knows both sides.
 *
 * A provider absent from this map contributes no extra tiers — it gets the
 * single-section Identity page, which is the correct page for it. Registering a
 * tier here is the ONLY thing needed to give a provider that section; the page
 * itself never changes.
 */

import type { IngestionRuleSection } from './shared/ingestion/ruleSections';
import { VendorDefaultRulesSection } from './modules/accounting/components/VendorDefaultRulesSection';
import { IngestionAutomationRulesSection } from './modules/accounting/components/IngestionAutomationRulesSection';

export const INGESTION_RULE_SECTIONS: Readonly<
  Record<string, readonly IngestionRuleSection[]>
> = {
  'accounting.bill': [
    { tier: 'defaults', Component: VendorDefaultRulesSection },
    { tier: 'automation', Component: IngestionAutomationRulesSection },
  ],
};
